import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';
import { CooperativeFilterOptions } from 'types/FilterOptions';

interface Props {
  cooperative: CooperativeFilterOptions | null | undefined;
}

export const CooperativeCheckbox = ({ cooperative }: Props) => {
  const intl = useIntl();

  if (!cooperative) {
    return null;
  }

  return (
    <StyledQmarkCheckboxes>
      <Checkbox
        itemClassName={'filter-single-checkbox'}
        name={'cooperative'}
        options={[
          {
            label: intl.formatMessage({ id: 'form.cooperative_filter_title' }),
            value: cooperative.value,
          },
        ]}
      />
    </StyledQmarkCheckboxes>
  );
};
